const headerTypes = {
  NONE: 'NONE',
  REGULAR: 'REGULAR',
  BACK: 'BACK',
  LOGO_ONLY: 'LOGO_ONLY',
};

export default headerTypes;
